import React, {useEffect, useState} from 'react';
import {Route, Redirect, Switch} from 'react-router-dom';
import cookie from 'js-cookie';
import {find} from 'lodash';

import {ROLES} from '../../constants';
import AuthorizedRoute from '../security/AuthorizedRoute';
import AppHeader from './AppHeader';
import Layout from './Layout';
import DashboardRoutes from '../dashboard/Routes';
import CustomerRoutes from '../customers/IndexScreen';
import AuditRoutes from '../audits/IndexScreen';
import BlacklistRoutes from '../blacklists/IndexScreen';
import WhitelistRoutes from '../whitelists/IndexScreen';
import OrderHistory from '../customers/OrderHistory';
import SettingRoutes from '../settings/Routes';
import UserRoutes from '../users/IndexScreen';
import {Modal, Header, Button} from 'semantic-ui-react';
import settings from '../../store/services/settings';
import ResourceList from '../resources/resource-listing';

const MainLayout = ({children}) => {
  const [modalContent, setModalContent] = useState(false);
  useEffect(() => {
    (async () => {
      if (!cookie.get('modal-show')) {
        const {result} = await settings.fetch();
        const content = find(result, {key: 'Modal Content'});
        cookie.set('modal-show', 'true');
        setModalContent({__html: content.value.replace(/\n/gi, '<br>')});
      }
    })();
  }, []);
  return (
    <Layout>
      <AppHeader />
      <Layout.Fill>
        <Switch>
          <Route path="/product-documentation" component={DashboardRoutes} />
          <Route path="/resources" component={ResourceList} />
          <AuthorizedRoute
            path="/order-history"
            component={OrderHistory}
            roles={[ROLES.CUSTOMER_ADMIN]}
          />
          <AuthorizedRoute
            path="/manage/blacklists"
            component={BlacklistRoutes}
            roles={[ROLES.SYSTEM_ADMIN]}
          />
          <AuthorizedRoute
            path="/manage/whitelists"
            component={WhitelistRoutes}
            roles={[ROLES.SYSTEM_ADMIN]}
          />
          <AuthorizedRoute
            path="/manage/customers"
            component={CustomerRoutes}
            roles={[ROLES.MM_ADMIN, ROLES.SYSTEM_ADMIN]}
          />
          <AuthorizedRoute
            path="/manage/searches"
            component={AuditRoutes}
            roles={[ROLES.MM_ADMIN, ROLES.SYSTEM_ADMIN]}
          />
          <AuthorizedRoute
            path="/manage/users"
            component={UserRoutes}
            roles={[ROLES.CUSTOMER_ADMIN, ROLES.MM_ADMIN, ROLES.SYSTEM_ADMIN]}
          />
          <AuthorizedRoute
            path="/manage/settings"
            component={SettingRoutes}
            roles={[ROLES.SYSTEM_ADMIN]}
          />
          <Redirect to="/product-documentation" />
        </Switch>
      </Layout.Fill>
      <Modal
        open={!!modalContent}
        onClose={() => setModalContent(false)}
        centered={false}
        size="tiny"
      >
        <Modal.Content>
          <Header
            size="large"
            textAlign="center"
            style={{
              fontWeight: 'normal',
              borderBottom: 'solid 2px #DFAE38',
              display: 'inline-block',
            }}
          >
            Welcome to the M&M Int’l Product Documentation Portal!
          </Header>
          <p dangerouslySetInnerHTML={modalContent}></p>
          <Button
            primary
            style={{marginTop: 15}}
            onClick={() => setModalContent(false)}
          >
            Continue
          </Button>
        </Modal.Content>
      </Modal>
    </Layout>
  );
};

export default MainLayout;